import { createCollectionStore } from "../../../shared/data/createCollectionStore.js";
import { getItems, createItem, updateItem, deleteItem } from "../services/itemService.js";

// Shared, cached list of items with in-flight de-duplication
export const itemStore = createCollectionStore(getItems, {
  errorMessage: "Unable to load items. Check your database connection."
});

export function useItems() {
  const { data: items, loading, error } = itemStore.useStore();
  const fetchItems = itemStore.refresh;

  const addItem = async (itemData) => {
    const id = await createItem(itemData);
    await fetchItems();
    return id;
  };

  const editItem = async (id, itemData) => {
    await updateItem(id, itemData);
    await fetchItems();
  };

  const removeItem = async (id) => {
    await deleteItem(id);
    await fetchItems();
  };

  return {
    items,
    loading,
    error,
    refetch: fetchItems,
    addItem,
    editItem,
    removeItem
  };
}

export default useItems;
